<script>
import { mapState } from 'vuex';

export default {
  name: 'LoginLayout',
  components: {},
  data() {
    return {
      sessionInterval: null,
    };
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.ui.isMobile,
    }),
  },
  mounted() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
    setInterval(this.validSession, 60000);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
  },
  methods: {
    checkMobile() {
      const screenWidth = window.innerWidth;
      const isMobile = screenWidth <= 1023;
      this.$store.commit('ui/SET_DATA', { key: 'isMobile', data: isMobile });
    },
  },
};
</script>

<template>
  <div class="main-admin-layout">
    <main class="admin-content">
      <router-view />
    </main>
  </div>
</template>
